import { BsSuitHeart } from 'react-icons/bs'

import PageAside from '../../components/pageaside/PageAside'
import Empty from '../empty/Empty'

import './relation.css'

const Relation = ({relation, isCurrent, isSetCurrent, isSetShow}) => {

      if(relation.data){
            return (
                  <div className={isCurrent === 'relation' ? "page_content show" : "page_content"}>
                        <Empty text={`Texto here`}/>
                  </div>
            )
      }

      const onClose = () => {
            isSetShow(false)
            isSetCurrent('home')
      }

      return (
            <div className={isCurrent === 'relation' ? "page_content show" : "page_content"}>
                  <div className="page_section">
                        <div className="wrapper_relation">
                              <div className="relation_header">
                                    <div className="relation_header__avatar">
                                          <img src={relation.avatar} alt={relation.name} />
                                    </div>
                                    <div className="relation_header__data">
                                          <h2 className="bg_grad">{relation.name}</h2>
                                          <p><strong>{relation.id_xat}</strong><a href={relation.me} target="_blank" rel="noreferrer">xat.me</a></p>
                                    </div>
                              </div>
                              <div className="relation_content">
                                    <p>{relation.about}</p>
                              </div>
                              <div className="relation_footer">
                                    <p>{relation.love_count.time_lapse}</p>
                                    <div className="relation_time">
                                          <div className="relation_time__box">
                                                <strong>{relation.love_count.day_amount}</strong>
                                                <span>Days</span>
                                          </div>
                                          <div className="relation_icon"><BsSuitHeart /></div>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <PageAside closePage={() => onClose()} title={relation?.relation_type ? relation.relation_type : "Crush"} />
            </div>
      )
}

export default Relation
